import {QueueAgent, QueueData} from '@gt-api';

export enum QueueStatus {
  STATUS_LOGGEDIN = 'status.logged_in',
  STATUS_INACTIVE = 'status.inactive',
  STATUS_LOGGEDOUT = 'status.logged_out'
}

export enum QueueStatusColor {
  STATUS_GREEN = 'color-green',
  STATUS_GRAY = 'color-gray',
  STATUS_RED = 'color-red'
}

// preemptive model for tnN
export class QueueAgentModel {
  organization?: string;
  login?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  serviceNumber?: string;
  cid?: number;
  state?: number;
  active?: boolean;
  skillLevel?: number;
  noReplyTime?: number;
  wrapupTime?: number;

  static fromQueueAgent(queueAgent: QueueAgent): QueueAgentModel {
    return queueAgent;
  }
}

// preemptive model for tnN
export class QueueDataModel {
  serviceNumber?: string;
  cid?: number;
  name?: string;
  maxPositions?: number;
  maxTime?: number;
  kickoutNoAgents?: number;
  type?: number;
  calls?: number;
  maxWaitTime?: number;
  agentsLoggedIn?: number;
  agentsAvailable?: number;
  pattern?: string;
  queueAgents?: Array<QueueAgentModel>;
  firstCreationTime: Date;

  static fromQueueData(queueData: QueueData): QueueDataModel {
    return {
      serviceNumber: queueData.serviceNumber,
      cid: queueData.cid,
      name: queueData.name,
      maxPositions: queueData.maxPositions,
      maxTime: queueData.maxTime,
      kickoutNoAgents: queueData.kickoutNoAgents,
      type: queueData.type,
      calls: queueData.calls,
      maxWaitTime: queueData.maxWaitTime,
      agentsLoggedIn: queueData.agentsLoggedIn,
      agentsAvailable: queueData.agentsAvailable,
      queueAgents: queueData.queueAgents,
      firstCreationTime: null
    };
  }
}
